import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class ListTargetCompaniesTask extends GenericRequest {

    _request;

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.MESSAGE_LIST_TARGET_COMPANIES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/card/ws/ListTargetCompaniesTask.js